import script from "./SecondLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondLevel.vue?vue&type=script&setup=true&lang=js"

import "./SecondLevel.vue?vue&type=style&index=0&id=533f775e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533f775e"]])

export default __exports__